import { render, staticRenderFns } from "./CreateStaff.vue?vue&type=template&id=29b33a32&scoped=true&"
import script from "./CreateStaff.vue?vue&type=script&lang=js&"
export * from "./CreateStaff.vue?vue&type=script&lang=js&"
import style0 from "./CreateStaff.vue?vue&type=style&index=0&id=29b33a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b33a32",
  null
  
)

export default component.exports